class RegistrationDetails {
  constructor(shareCode, forename, surname, phonenumber, email, password,
    postcode, addAsBuddy, useReferrersHomeClub, overrideUId) {
    this.emailAddress = email;
    this.password = password;
    this.forename = forename;
    this.surname = surname;
    this.phonenumber = phonenumber;
    this.postcode = postcode;
    this.shareCode = shareCode;
    this.addAsBuddy = addAsBuddy;
    this.useReferrersHomeClub = useReferrersHomeClub;
    this.overrideUId = overrideUId;
  }
}

export { RegistrationDetails };
